export default {
	dashboard: "Panel",
	users: "Usuarios",
	consultants: "Consultantes",
	mediums: "Corriente",
	functions: "Funciones",
	spiritualLines: "Líneas Espirituales",
	guides: "Guías Espirituales",
	orixas: "Orixás",
	ritualTypes: "Tipos de Rituales",
	rituals: "Rituales",
	journeyStages: "Etapas del Viaje",
	logout: "Salir",
	wisdomQuotes: "Frases de Sabiduría",
	import: "Importación",
	billing: "Mi Plan",
	manual: "Manual",
	support: "Soporte",
	attendanceTypes: "Tipos de Atención",
	displayMessages: "Display / TV",
	templeInvites: "Invitaciones",
	templeSettings: "Configuraciones",
};
